import { isValidUuid } from "../general";

export function uuidOnlyObjectEntries<T extends { [key: string]: unknown }>(object: T): T {
    return Object.entries(object)
        .filter(([key]) => isValidUuid(key))
        .reduce((cum, [key, value]) => ({ ...cum, [key]: value }), {} as T);
}
